export const SMS_RESET = 'SMS_RESET';
export const SMS_SENDING = 'SMS_SENDING';
export const SMS_SENT = 'SMS_SENT';
export const SMS_ERROR = 'SMS_ERROR';
